import { forwardRef, type RefObject } from 'react';

import {
  Canvas,
  type CanvasRef,
} from '../../../core/components/canvas/Canvas.js';
import { CanvasContext } from '../../../core/components/canvas/CanvasContext.js';
import type { CanvasShape } from '../../../core/components/canvas/types/canvas-shape.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { useHistogramXScale } from '../../hooks/useHistogramXScale.js';
import type { HistogramSeries } from '../../types/histogram.js';
import { BarChartDisplay } from '../displays/BarChartDisplay.js';

interface HistogramGenericCanvasLayoutProps {
  series: HistogramSeries[];
}

export const HistogramGenericCanvasLayout = forwardRef<
  CanvasRef,
  HistogramGenericCanvasLayoutProps
>((props: HistogramGenericCanvasLayoutProps, canvasRef) => {
  const { series } = props;
  const { width, height } = useGridPlotSize();
  const { xScale } = useHistogramXScale();

  return (
    <CanvasContext.Provider
      value={{
        shapeRefs: new Map<string, RefObject<CanvasShape>>(),
      }}
    >
      <Canvas width={width} height={height} ref={canvasRef}>
        <BarChartDisplay xScale={xScale} series={series} />
      </Canvas>
    </CanvasContext.Provider>
  );
});
